import templateComponents from '../../../Template/theme/components'
import auto from './auto'

export default {
    ...templateComponents,
    auto
}


// WEBPACK FOOTER //
// ./src/app/configuration/FordLincoln/theme/components/index.js